/**
 * Query-key roots for the core modules. Feature query keys must start with one of these so realtime
 * hints (prefix-matched) refresh them.
 */
export const coreKeys = {
  pipeline: ['pipeline'] as const,
  accounts: ['accounts'] as const,
  targets: ['targets'] as const,
  touches: ['touches'] as const,
  playbook: ['playbook'] as const,
  library: ['library'] as const,
  imports: ['import'] as const,
};
